{#if open}
  <div class="cms-alert-box" transition:fade={{ duration: 200 }}>
    <div class="cms-alert-box--top">
      <div class="cms-alert-box--icon"
        style:color={variant === 'warning' ? 'red' : '#3961ca'}
      >
        {icon}
      </div>

      <div class="cms-alert-box--heading"
        style:color={variant === 'warning' ? 'red' : '#3961ca'}
      >
        {heading}
      </div>
    </div>

    <div class="cms-alert-box--bottom">
      {#if text}
        <div class="cms-alert-box--text">
          <p>{text}</p>
        </div>
      {/if}

      {#if warningText}
        <div class="cms-alert-box--text">
          <p class="text-red-500">{warningText}</p>
        </div>
      {/if}

      <div class="cms-alert-box--buttons">
        {#if cancelButton}
          <button class="cms-alert-box--button cms-alert-box--cancel" on:click|preventDefault={() => dispatch('cancel')}>{cancelButton}</button>
        {/if}

        {#if confirmButton}
          <button class="cms-alert-box--button cms-alert-box--confirm" on:click|preventDefault={() => dispatch('confirm')}
            style:background={variant === 'warning' ? 'red' : '#3961ca'}
            style:color={variant === 'warning' ? 'white' : ''}
          >
            {confirmButton}
          </button>
        {/if}
      </div>
    </div>
  </div>

  <div class="cms-alert-box--background" />
{/if}

<script>
  import { fade } from 'svelte/transition'
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()

  export let open = false
  export let icon = 'delete'
  export let heading = 'Are you sure?'
  export let text = ''
  export let warningText = ''
  export let cancelButton = ''
  export let confirmButton = ''
  export let variant = 'normal'
</script>

<style>
  .cms-alert-box {
    font-family: Roboto;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
    position: fixed;
    z-index: 99999;
    left: 50%;
    transform: translateX(-50%);
    top: 20vh;
  }

  .cms-alert-box--bottom {
    border-top: 1px solid rgba(34,36,38,.05);
    background: #f8f8f8;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 40px;
    border-radius: 10px;
  }

  .cms-alert-box--icon {
    font-family: "Material Icons";
    font-size: 42px;
    margin-bottom: 5px;
  }

  .cms-alert-box--heading {
    font-size: 22px;
    font-weight: 400;
  }

  .cms-alert-box--buttons {
    display: flex;
    justify-content: space-between;
  }

  .cms-alert-box--button {
    border-radius: 3px;
    color: #656565;
    border: 1px solid rgba(34,36,38,.15);
    background: #fff;
    padding: 12px 20px;
    margin: 0px 5px;
    cursor: pointer;
    font-size: 1.2rem;
  }

  .cms-alert-box--confirm {
    background: #3961ca;
    color: #fff;
  }

  .cms-alert-box--top {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 40px;
  }

  .cms-alert-box--text p {
    max-width: 325px;
    font-size: 1.1rem;
    margin-top: 0px;
    margin-bottom: 20px;
  }

  .cms-alert-box--background {
    width: 100%;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 9998;
    filter: blur(2px);
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>